// extracted by mini-css-extract-plugin
module.exports = {"root":"_aab5f8","dividers":"_4b3288"};